import canvasEnums from '../../enums/canvas';
import { getCommonStyle } from '../styleCommon';

export function getAxesStyles() {

	const color = '#666';
	const background = { color: null };
	const commonFontFamily = getCommonStyle('font.family');
	const commonAccentSecondary = getCommonStyle('color.accent.secondary');
	const font = {
		family: commonFontFamily,
		size: 11,
		weight: 'normal'
	};

	return {
		xAxis: {
			background,
			font,
			bottomRow: {
				label: {
					color: null
				},
				font: {
					weight: null,
					size: null,
					family: null
				}
			},
			label: {
				color,
				lineHeight: null,
				overlap: {
					right: 8,
					left: 0 // Not supported yet
				},
				padding: {
					left: 3,
					right: 3,
					top: 5
				},
				spacing: {
					default: 50,
					minutes: 75
				},
				steps: {
					minutes: [1, 5, 10, 15, 30],
					hours: [1, 2, 4],
					days: [1, 2, 3],
					weeks: [1, 2, 4, 16],
					months: [1, 2, 3, 4, 6],
					years: [1, 2, 5, 10]
				},
				textAlign: canvasEnums.textAlign.LEFT
			},
			// Padding for XAxis domain (as opposed to padding for labels)
			padding: {
				left: 0,
				right: 0
			},
			tick: {
				alt: {
					color: commonAccentSecondary,
					length: 8,
					lineDash: null,
					width: null
				},
				color: commonAccentSecondary,
				length: 4,
				lineDash: '',
				width: 1
			}
		},
		yAxis: {
			background,
			font,
			label: {
				color,
				format: {
					default: { // any number that doesn't meet the other thresholds (large/small/micro) will use these formats
						format: '0,.2f', // e.g. 123.45
						formatPercent: '0,.2%' // e.g. 12.34%
					},
					large: {
						format: '0,.2s', // e.g. 600k
						formatPercent: '0,.0%', // e.g. 12%
						threshold: 5000 // steps greater or equal to this will use the large format
					},
					small: {
						format: '0.3f', // e.g. 0.123
						formatPercent: '0.2%', // e.g. 12.34%
						threshold: 0.01 // steps less than this will use the small format
					},
					micro: {
						format: '0.4f',
						formatPercent: '0.2%', // e.g. 12.34%
						threshold: 0.001 // steps less than this will use the micro format
					}
				},
				// Flag labels often need slightly different thresholds than axis labels.
				// For instance the axis labels may be round steps '600k, 500k, 400k' but the flag's format string should have
				// more granularity, like '524,010', so that the user knows the exact number the flag is pointing to.
				flag: {
					format: {
						default: { // any number that doesn't meet the "large" or "small" thresholds will use these formats
							format: '0,.2f', // e.g. 123.45
							formatPercent: '0,.2%' // e.g. 12.34%
						},
						large: {
							format: '0,.0f', // e.g. 12,345
							formatPercent: '0,.2%', // e.g. 12.34%
							threshold: 10000 // numbers greater or equal to this will use the large format
						},
						small: {
							format: '0.3f', // e.g. 0.123
							formatPercent: '0,.2%', // e.g. 12.34%
							threshold: 1 // numbers less than this will use the small format
						}
					}
				},
				// Padding for YAxis labels (as opposed to padding for domain)
				// i.e. this is the padding directly around the text of the label, like "25.6%"
				padding: {
					bottom: 3,
					left: 5,
					right: 5,
					top: 3
				},
				spacing: {
					default: 50,
					small: 30
				},
				textAlign: canvasEnums.textAlign.LEFT,
				textBaseline: canvasEnums.textBaseline.MIDDLE,
				threshold: {
					small: 170
				},
				vertical: {
					right: {
						font,
						offsetX: 0
					}
				}
			},
			// Padding for YAxis domain (as opposed to padding for labels)
			// This only applies vertically, and adds padding to the top and bottom of the entire YAxis.
			padding: {
				top: 15,
				bottom: 15
			},
			tick: {
				color: null,
				length: 4,
				lineDash: '',
				width: null
			}
		}
	};
}
